const nb = {
  layout: {
    cos_button: {
      phone: 'Telefon',
      update_phone_number_message: 'Telefonnummeret ble oppdatert!'
    },
    time: {
      days: 'Dager',
      hours: 'Timer',
      mins: 'Min',
      secs: 'Sek',
      starts: 'Starter',
      starts_immediately: 'Starter umiddelbart'
    },
    field: {
      host: 'Vert'
    },
    copy: 'Kopier'
  },
  validations: {
    email: 'Må være en gyldig mailadresse',
    phone: 'Må være et gyldig telefonnummer',
    required_field: 'Obligatorisk'
  },
  mailer: {
    need_help: 'Trenger du hjelp?',
    stop_reminders: 'Slutt å motta påminnelser',
    cancel_registration: 'Kanseller registreringen',
    report_abuse: 'Rapporter misbruk'
  },
  datetime: {
    no_sessions: 'Ingen tilgjengelige tidspunkter',
    empty_label: 'Dato/tid'
  },
  errors: {
    verification_failed: 'Verifiseringen mislyktes. Vennligst prøv igjen.',
    session_unavailable: 'Tidspunktet du valgte er ikke lenger tilgjengelig. Velg et annet tidspunkt.',
    challenge_email_mismatch:
      'Registrer deg med samme e-postadresse som du brukte da du registrerte deg for arrangementet.'
  }
}

export default nb
